/* NW AGENCY ENHANCEMENTS - Predictive Search + Theme Toggle */
(function() {
  'use strict';

  /* === PREDICTIVE SEARCH === */
  function initPredictiveSearch() {
    var inputs = document.querySelectorAll('.search-overlay__input, .search-form__input');
    inputs.forEach(function(input) {
      var wrapper = input.closest('.search-overlay__inner') || input.closest('.search-form-wrapper');
      if (!wrapper) return;
      wrapper.style.position = 'relative';
      var el = document.createElement('div');
      el.className = 'predictive-search';
      wrapper.appendChild(el);
      var timer;
      input.addEventListener('input', function() {
        var q = this.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { el.classList.remove('predictive-search--open'); el.innerHTML = ''; return; }
        el.innerHTML = '<div class="predictive-search__loading"><div class="predictive-search__spinner"></div>Suche...</div>';
        el.classList.add('predictive-search--open');
        timer = setTimeout(function() { doFetch(q, el); }, 300);
      });
      input.addEventListener('focus', function() {
        if (el.innerHTML && this.value.trim().length >= 2) el.classList.add('predictive-search--open');
      });
      document.addEventListener('click', function(e) {
        if (!wrapper.contains(e.target)) el.classList.remove('predictive-search--open');
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') el.classList.remove('predictive-search--open');
      });
    });
  }

  function doFetch(q, c) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=4&resources[options][unavailable_products]=last')
      .then(function(r) { if (!r.ok) throw 0; return r.json(); })
      .then(function(d) { render(d.resources.results, q, c); })
      .catch(function() { c.innerHTML = '<div class="predictive-search__empty">Drücke Enter um zu suchen</div>'; });
  }

  function render(r, q, c) {
    var h = '', pr = r.products || [], ar = r.articles || [], pg = r.pages || [];
    if (!pr.length && !ar.length && !pg.length) {
      c.innerHTML = '<div class="predictive-search__empty">Keine Vorschläge für "' + esc(q) + '"</div>';
      return;
    }
    if (pr.length) {
      h += '<div class="predictive-search__group"><div class="predictive-search__heading">Produkte</div>';
      pr.forEach(function(p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy" width="52" height="52">' : '<div class="predictive-search__image-placeholder">🛠</div>';
        var price = p.price ? fmt(p.price) : '';
        h += '<a href="' + p.url + '" class="predictive-search__item">';
        h += '<div class="predictive-search__image">' + img + '</div>';
        h += '<div class="predictive-search__info"><div class="predictive-search__title">' + hl(p.title, q) + '</div>';
        if (p.product_type) h += '<div class="predictive-search__meta">' + esc(p.product_type) + '</div>';
        h += '</div>';
        if (price) h += '<div class="predictive-search__price">' + price + '</div>';
        h += '</a>';
      });
      h += '</div>';
    }
    if (ar.length) {
      h += '<div class="predictive-search__group"><div class="predictive-search__heading">Blog</div>';
      ar.forEach(function(a) {
        var img = a.image ? '<img src="' + a.image + '" alt="' + esc(a.title) + '" loading="lazy" width="52" height="52">' : '<div class="predictive-search__image-placeholder">📝</div>';
        h += '<a href="' + a.url + '" class="predictive-search__item"><div class="predictive-search__image">' + img + '</div><div class="predictive-search__info"><div class="predictive-search__title">' + hl(a.title, q) + '</div></div></a>';
      });
      h += '</div>';
    }
    if (pg.length) {
      h += '<div class="predictive-search__group"><div class="predictive-search__heading">Seiten</div>';
      pg.forEach(function(p) {
        h += '<a href="' + p.url + '" class="predictive-search__item"><div class="predictive-search__image"><div class="predictive-search__image-placeholder">📄</div></div><div class="predictive-search__info"><div class="predictive-search__title">' + hl(p.title, q) + '</div></div></a>';
      });
      h += '</div>';
    }
    h += '<a href="/search?q=' + encodeURIComponent(q) + '" class="predictive-search__all">Alle Ergebnisse anzeigen →</a>';
    c.innerHTML = h;
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function hl(t, q) { var e = esc(t); return e.replace(new RegExp('(' + q.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&') + ')', 'gi'), '<strong style="color:var(--cyan)">$1</strong>'); }
  function fmt(c) {
    var n = parseFloat(String(c).replace(',', '.'));
    if (isNaN(n)) return '';
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\\B(?=(\\d{3})+(?!\\d))/g, '.');
    return '€' + parts[0] + ',' + parts[1];
  }

  /* === THEME MODE TOGGLE === */
  function initThemeToggle() {
    var saved = null;
    try { saved = localStorage.getItem('nw-theme-mode'); } catch(e) {}
    document.documentElement.setAttribute('data-theme', saved || 'dark');

    var btn = document.createElement('button');
    btn.className = 'theme-toggle';
    btn.setAttribute('aria-label', 'Theme wechseln');
    btn.innerHTML = '<svg class="theme-toggle__sun" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg><svg class="theme-toggle__moon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';

    function toggleTheme() {
      var cur = document.documentElement.getAttribute('data-theme');
      var nxt = cur === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', nxt);
      try { localStorage.setItem('nw-theme-mode', nxt); } catch(e) {}
    }
    btn.addEventListener('click', toggleTheme);

    var hr = document.querySelector('.header-right');
    if (hr) hr.insertBefore(btn, hr.firstChild);

    var mf = document.querySelector('.mobile-menu__footer');
    if (mf) {
      var mb = btn.cloneNode(true);
      mb.style.marginBottom = '12px';
      mb.addEventListener('click', toggleTheme);
      mf.insertBefore(mb, mf.firstChild);
    }
  }

  /* === INIT === */
  function init() { initPredictiveSearch(); initThemeToggle(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
